// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './pages/Home';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Friends from './pages/Friends';
import Leaderboard from './pages/Leaderboard';
import Settings from './pages/Settings';
import History from './pages/History';
import Match from './pages/Match';
import { SocketProvider } from './SocketContext'; // Import SocketProvider
import { MatchWait } from './pages/MatchWait';
import { WaInviteWait } from './pages/WaInviteWait';
import FindMatch from './pages/FindMatch';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SocketProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/signup" element={<SignUp />} />
        <Route path="/friends" element={<Friends />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/history" element={<History />} />
        <Route path="/matchwait" element={<MatchWait />} />
        <Route path="/match" element={<Match />} />
        <Route path="/waInviteWait" element={<WaInviteWait />} />
        <Route path="/findMatch" element={<FindMatch />} />
      </Routes>
    </BrowserRouter>
  </SocketProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
